import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import './Navbar.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  
  // Always call useCart hook
  const cart = useCart();
  const cartItemsCount = cart ? cart.getCartItemsCount() : 0;

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <nav className="navbar">
      <div className="nav-container">
        <div className="nav-logo">
          <Link to="/" onClick={closeMenu}>
            <h2>بصمة آثر وآركان أكاديمي</h2>
          </Link>
        </div>
        <ul className={`nav-menu ${isOpen ? 'active' : ''}`}>
          <li className="nav-item">
            <Link 
              to="/" 
              className={`nav-link ${isActive('/') ? 'active' : ''}`}
              onClick={closeMenu}
            >
              الرئيسية
            </Link>
          </li>
          <li className="nav-item">
            <Link 
              to="/books" 
              className={`nav-link ${isActive('/books') ? 'active' : ''}`}
              onClick={closeMenu}
            >
              الكتب
            </Link>
          </li>
          <li className="nav-item">
            <Link 
              to="/gallery" 
              className={`nav-link ${isActive('/gallery') ? 'active' : ''}`}
              onClick={closeMenu}
            >
              معرض الأعمال
            </Link>
          </li>
          <li className="nav-item">
            <Link 
              to="/interviews" 
              className={`nav-link ${isActive('/interviews') ? 'active' : ''}`}
              onClick={closeMenu}
            >
              حوارات صحفية
            </Link>
          </li>
          <li className="nav-item">
            <Link 
              to="/about" 
              className={`nav-link ${isActive('/about') ? 'active' : ''}`}
              onClick={closeMenu}
            >
              من نحن
            </Link>
          </li>
          <li className="nav-item">
            <Link 
              to="/contact" 
              className={`nav-link ${isActive('/contact') ? 'active' : ''}`}
              onClick={closeMenu}
            >
              تواصل معنا
            </Link>
          </li>
          <li className="nav-item">
            <Link 
              to="/admin/login" 
              className={`nav-link admin-link ${isActive('/admin/login') ? 'active' : ''}`}
              onClick={closeMenu}
            >
              ⚙️ الإدارة
            </Link>
          </li>
          <li className="nav-item cart-item">
            <Link 
              to="/cart" 
              className={`nav-link cart-link ${isActive('/cart') ? 'active' : ''}`}
              onClick={closeMenu}
            >
              <span className="cart-icon">🛒</span>
              {cartItemsCount > 0 && (
                <span className="cart-count">{cartItemsCount}</span>
              )}
            </Link>
          </li>
        </ul>
        <div className={`hamburger ${isOpen ? 'active' : ''}`} onClick={toggleMenu}>
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
